import memoize from 'memoizee';
import {
	useWebsiteReportsDefaultAlertsFormQuery,
} from '~/components/atoms/forms/forms/WebsiteReportsDefaultAlertsForm.gql';
import type CK from '~/types/contentking';



const format = memoize(
	(data: any) => {
		const user = data?.user ?? null;
		const account = data?.account ?? null;
		const isLoaded = user !== null && account !== null;
		if (!isLoaded) {
			return {
				isLoaded: false,
				getUser: () => null,
				getAccount: () => null,
				listDefaults: () => [],
			};
		}

		const getUser = () => user;
		const getAccount = () => account;
		const listDefaults = () => {
			if (!account?.websitesAlerts) { return []; }
			return account.websitesAlerts.map((wa: any) => ({
				websiteId: wa.websiteId,
				alerts: wa.alerts,
				reports: wa.reports,
			}));
		};

		return { isLoaded, getUser, getAccount, listDefaults };
	}
);

function useAllWebsitesDefaultAlertsAndReports(userId: CK.UserId, accountId: CK.AccountId) {
	const { data } = useWebsiteReportsDefaultAlertsFormQuery({
		variables: {
			userId,
			accountId,
		}
	});
	return format(data);
}

export default useAllWebsitesDefaultAlertsAndReports;
